import {
  ADMIN_SCAN_PAY,
  USER_WALLET_TRANSACTIONS_MAIN,
  USER_WALLET_TRANSACTIONS,
  GET_ALL_DONATIONS,
  GET_ALL_DONATIONS_REPORT,
  GET_ALL_VENDOR_SETTLEMENT,
  SINGLE_VENDOR_SETTLEMENT,
  GET_PAYMENT_HISTORY,
  GET_ALL_VENDOR_STATEMENT,
  SINGLE_VENDOR_STATEMENT,
} from "../../types";

const initialState = {
  scan_pay: [],
  user_wallet_transactions_main: [],
  user_wallet_transactions: [],
  all_donations: [],
  all_donations_report: [],
  all_vendor_settlement: [],
  all_vendor_statement: [],
  single_vendor_settllement: {},
  single_vendor_statement: {},
  payment_history: [],
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case ADMIN_SCAN_PAY:
      return {
        ...state,
        scan_pay: payload,
      };
    case USER_WALLET_TRANSACTIONS_MAIN:
      return {
        ...state,
        user_wallet_transactions_main: payload,
      };
    case USER_WALLET_TRANSACTIONS:
      return {
        ...state,
        user_wallet_transactions: payload,
      };
    case GET_ALL_DONATIONS:
      return {
        ...state,
        all_donations: payload,
      };
    case GET_ALL_DONATIONS_REPORT:
      return {
        ...state,
        all_donations_report: payload,
      };

    case GET_ALL_VENDOR_SETTLEMENT:
      return {
        ...state,
        all_vendor_settlement: payload,
      };
    case GET_ALL_VENDOR_STATEMENT:
      return {
        ...state,
        all_vendor_statement: payload,
      };
    case SINGLE_VENDOR_SETTLEMENT:
      return {
        ...state,
        single_vendor_settllement: payload,
      };

    case SINGLE_VENDOR_STATEMENT:
      return {
        ...state,
        single_vendor_statement: payload,
      };

    case GET_PAYMENT_HISTORY: {
      return {
        ...state,
        payment_history: payload,
      };
    }

    default:
      return state;
  }
}
